import { remove } from '../index';

export const deleteParameter = data => {
  return remove(`/parameters` , data);
};